"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerInquiryAccountStatusReason = void 0;
// Partner-facing reason surfaced on the dashboard for an inquiry's card account status —
// covers both terminal closures (CLOSED, charged off, sold, …) and non-terminal restrictions
// (blocked, delinquent, 90-days-past-due). Customer-requested closures collapse to
// CUSTOMER_REQUESTED; ops-side reasons keep full per-status granularity.
var PartnerInquiryAccountStatusReason;
(function (PartnerInquiryAccountStatusReason) {
    PartnerInquiryAccountStatusReason["CUSTOMER_REQUESTED"] = "customer_requested";
    PartnerInquiryAccountStatusReason["DELINQUENT"] = "delinquent";
    PartnerInquiryAccountStatusReason["FRAUD"] = "fraud";
    PartnerInquiryAccountStatusReason["CHARGED_OFF"] = "charged_off";
    PartnerInquiryAccountStatusReason["BANKRUPTCY"] = "bankruptcy";
    PartnerInquiryAccountStatusReason["NINETY_DAYS_PAST_DUE"] = "ninety_days_past_due";
    PartnerInquiryAccountStatusReason["SOLD"] = "sold";
    PartnerInquiryAccountStatusReason["OFAC_SUSPENDED"] = "ofac_suspended";
    PartnerInquiryAccountStatusReason["BLOCKED"] = "blocked";
    PartnerInquiryAccountStatusReason["CLOSED_BY_OPS"] = "closed_by_ops";
    PartnerInquiryAccountStatusReason["OTHER"] = "other";
})(PartnerInquiryAccountStatusReason || (exports.PartnerInquiryAccountStatusReason = PartnerInquiryAccountStatusReason = {}));
